import { cn } from "@tine/designsystem-utils";
import { observer } from "mobx-react-lite";

import { type CmsContentSearchResults, SEARCH_TYPE, type SearchComponentProps } from "../../common/types/searchTypes";
import useSupportedLocale from "../../common/utils/useSupportedLocale";

import searchStore from "../../stores/search/searchStore";

import { InternalLink } from "../Links";
import CmsContentHit from "./CmsContentHit";

const hide = () => searchStore.clear(SEARCH_TYPE.QuickSearch, true);

const HitsForCmsContent = ({ searchDomain, maxHits = Number.MAX_VALUE, isNarrow = false }: SearchComponentProps) => {
   const results: CmsContentSearchResults | undefined = searchStore[SEARCH_TYPE.QuickSearch].results.find(
      (result) => result.name === searchDomain.name
   ) as CmsContentSearchResults | undefined;
   const hits = (results?.hits || []).slice(0, maxHits);
   const locale = useSupportedLocale();
   const containerCN = cn("grid gap-y-3", {
      "lg:grid-cols-3 lg:gap-x-8": !isNarrow
   });

   if (results && hits.length) {
      const { queryID } = results;
      return (
         <>
            <div>
               <h3 className="pb-2">{searchDomain.displayName(locale)}</h3>
            </div>
            <div className={containerCN}>
               {hits.map((hit, i) => (
                  <CmsContentHit
                     key={hit.objectID}
                     hit={hit}
                     position={i + 1}
                     locale={locale}
                     searchDomain={searchDomain}
                     queryID={queryID}
                  />
               ))}
            </div>
            <div>
               <InternalLink
                  className="my-2 inline-block p-2"
                  onClick={() => hide()}
                  href={`/search/${searchDomain.name}?q=${results.query}`}
               >{`${searchDomain.linkText(locale)} med '${results.query}'`}</InternalLink>
            </div>
         </>
      );
   }
   return null;
};

export default observer(HitsForCmsContent);
